module.exports = __webpack_public_path__ + "fae2d7c7c100492739ea2a347ded20e2.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-52.cur
// module id = 463
// module chunks = 0